const $ = window.jQuery

function headerUpdate() {
  if(!isTabletWidth()) {
    if($(window).scrollTop() > $('.header-bar').height()){
      $('.header').css('top', $('.header-bar').height() * -1);
    }else{
      $('.header').css('top', $(window).scrollTop() * -1);
    }
  } else {
    $('.header').css('top', '0');
  }
}

$(window).on( 'scroll', headerUpdate);

$( window ).resize(function() {
  headerUpdate();
});

$(() => {

  headerUpdate();

})
